import { render, staticRenderFns } from "./RegistrationNavbar.vue?vue&type=template&id=95e8cdc0"
import script from "./RegistrationNavbar.vue?vue&type=script&lang=js"
export * from "./RegistrationNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports